import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import moment from 'moment';
import Step10View from './Step10-view';
import types from '../../types';
import {checkNextStepAndGo} from '../../utils/checkNextStepAndGo';
import {useIntl} from "react-intl";
import {trackEvent} from "../../utils/trackEvent";

const Step10 = ({
                  submitStep,
                  regType,
                  prevCompletedStepSign,
                  prevCompletedStepSignFalse,
                }) => {
  const initialValues = {
    taxYear: new Date(),
  };

  const {formatMessage} = useIntl();

  const handleSubmit = values => {
    submitStep({
      step: 10,
      data: {
        regType,
        selectedYear: moment(values.taxYear).year(),
        prevCompletedStepSign
      },
    })
      .then(checkNextStepAndGo)
      .then(() => prevCompletedStepSignFalse())
      .then(() => trackEvent('signup_step',
          {
            step_number: 10,
            step_name_en: 'Income tax',
            step_name_he: formatMessage({id: 'step10.page.title', defaultMessage: ''}),
            regType
          }
        )
      )
      .catch(err => console.log({err}));
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      <Step10View/>
    </Formik>
  )
};

Step10.propTypes = {
  ...types.router,
  regType: PropTypes.string,
  submitStep: PropTypes.func
};

export default Step10;
